<template>
<div class="fit sticky-form-actions edit-panel">
    <q-btn class="close-panel right top position-absolute" color="grey-8" @click.prevent="closePanel" type="button" icon="close" size="12px" flat dense />
    <b-tabs borderless :style="'overflow-y: auto; height: 100vh; padding-bottom: ' + formActionsRowHeight + 'px; '">
        <b-tab class="p-0">
            <template slot="title">
                <div class="mt-2 mb-1">
                    <q-icon name="fas fa-group" class="mr-1" />{{ translate('customer_groups') }} 
                    <q-badge color="primary">{{ groups.length ? groups.length : '0' }}</q-badge>
                </div>
            </template>
            <b-list-group class="list-group-accent">
                <b-list-group-item class="p-3 wrapper_customer-groups-list">
                    <template v-if="groups.length">
                        <q-item dense class="shadow-2 p-2 mt-2 mb-2" v-for="group in groups" :key="group.id">
                            <q-item-section avatar>
                                <q-avatar class="shadow-2">
                                    <i class="fas fa-group fa-1x text-muted"></i>
                                </q-avatar>
                            </q-item-section>
                            <q-item-section>
                                <span class="text-muted" v-if="group.customer_is_owner === true || group.customer_is_member === true">
                                    <small class="mr-1" v-if="group.customer_is_owner === true">
                                        <i class="fas fa-crown text-orange"></i> 
                                        {{ translate('customer_group_owner') }}
                                    </small>
                                    <small v-if="group.customer_is_member === true">
                                        <i class="fas fa-user text-primary mr-1"></i> 
                                        {{ translate('customer_group_member') }}
                                    </small>
                                </span>
                                <q-item-label>{{ group.name }}</q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <small v-if="group.is_active" class="text-primary">
                                    <q-tooltip :offset="[10, 10]">{{ translate('customer_group_is_active') }}</q-tooltip>
                                    <template v-if="!$q.screen.lt.sm">{{ translate('customer_group_is_active') }}</template>
                                    <i class="fas fa-toggle-on ml-1"></i>
                                </small>
                                <small v-else class="text-dark">
                                    <q-tooltip :offset="[10, 10]">{{ translate('customer_group_is_not_active') }}</q-tooltip>
                                    <template v-if="!$q.screen.lt.sm">{{ translate('customer_group_is_not_active') }}</template>
                                    <i class="fas fa-toggle-off ml-1"></i>
                                </small>
                                <small v-if="group.is_approved" class="text-success">
                                    <q-tooltip :offset="[10, 10]">{{ translate('customer_group_is_approved') }}</q-tooltip>
                                    <template v-if="!$q.screen.lt.sm">{{ translate('customer_group_is_approved') }}</template>
                                    <i class="fas fa-check ml-1"></i>
                                </small>
                                <small v-else class="text-dark">
                                    <q-tooltip :offset="[10, 10]">{{ translate('customer_group_is_not_approved') }}</q-tooltip>
                                    <template v-if="!$q.screen.lt.sm">{{ translate('customer_group_is_not_approved') }}</template>
                                    <i class="fas fa-ban ml-1"></i>
                                </small>
                                <small v-if="group.is_deleted" class="text-danger">
                                    <q-tooltip :offset="[10, 10]">{{ translate('customer_group_is_deleted') }}</q-tooltip>
                                    <template v-if="!$q.screen.lt.sm">{{ translate('customer_group_is_deleted') }}</template>
                                    <i class="fas fa-trash ml-1"></i>
                                </small>
                            </q-item-section>
                        </q-item>
                    </template>
                    <template v-if="!groups || groups.length <= 0">
                        <q-item dense class="m-0 p-0">{{ translate('no_results') }}</q-item>
                    </template>
                </b-list-group-item>
                <div class="form-actions bottom bg-light" :style="'width: ' + slideoutTabsWidth + 'px'">
                    <q-item class="p-3">
                        <q-item-section></q-item-section>
                        <q-item-section side>
                            <q-btn @click.prevent="closePanel" type="button" no-caps color="dark">
                                <q-icon size="1rem" name="close" class="mr-1" /> {{ translate('cancel') }}
                            </q-btn>
                        </q-item-section>
                    </q-item>
                </div>
            </b-list-group>
        </b-tab>
    </b-tabs>
</div>
</template>

<script>
import { eventBus } from "../../../../main"

export default {
    name: 'CustomerGroups',
    props: ['customer_id'],
    data: function () {
        return {
            formActionsRowHeight: 0,
            slideoutTabsWidth: 0,

            groups: [],
        }
    },
    created() {
        eventBus.$on('update_list', this.getCustomerGroups)
        this.getCustomerGroups()
        this.getElementsWidthHeight()
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.getElementsWidthHeight)
    },
    mounted: function () {
        window.addEventListener('resize', this.getElementsWidthHeight)
    },
    methods: {
        getElementsWidthHeight: _.debounce(function () {
            this.formActionsRowHeight = document.querySelector('.form-actions').clientHeight
            this.slideoutTabsWidth = document.querySelector('.slideout .tabs').clientWidth
        }, 200),
        getCustomerGroups: function () {
            var groupUrl = baseUrl + 'customers/' + this.customer_id + '/groups'

            var headers = {
                'Authorization': 'Bearer ' + this.accessToken(),
            }
            axios.get(groupUrl, {
                    headers: headers
                })
                .then(response => {
                    this.groups = response.data.items.map(entity => {
                        let array = entity
                        array['image_link'] = entity.image_link ? baseUrl + entity.image_link : null
                        return array
                    })
                })
                .catch(function (error) {
                    // console.log(error)
                })
        },
        closePanel() {
            this.$emit('closePanel')
        }
    }
}
</script>